import styles from "./JoinCommunity.module.css"
import Button from "../Button";
import { Link } from "react-router-dom";

const JoinCommunity =()=>{
    return (
      <section className={styles.main}>
        <div className={styles.content}>
          <h2 className="h2-bold">Join the community</h2>
          <p className="h4-medium">
            Share your distortion grid assets and get a contributor discount on
            the library.
          </p>
          <div className={styles.btn}>
            <Link to="/affiliate-program">
              <Button variant="blue" label="Learn how" iconType="arrowRight"/>
            </Link>
          </div>
        </div>
      </section>
    );
}

export default JoinCommunity
